import React, { Component } from 'react'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  FieldWrapper,
  LevelRowContainer,
  MainWrapper,
  RoundedWrapper,
} from './styles'
import { withRouter } from 'react-router'
import { withTheme } from 'styled-components'
import { InputCol } from '../ActualLoadingFinalizeForm/styles'
import { Label } from 'components/atoms/Texts/TxtLabel'
import FormSelect from 'components/atoms/Inputs/FormSelect'
import {
  CustomFormatDateInput,
  TimeInputTwoVersion,
} from 'components/molecules/DateTimeInput/index'
import moment from 'moment'
import Attachments from './Attachments'
import lo from 'lodash'
import { getAllAreasData } from 'Redux/actions/AreaActions'
import ReactSelect from 'react-select'

export class StockOpnameHeaderForm extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidUpdate(prevProps, prevState) {
    const { form, onChange } = this.props

    if (form['period'] !== prevProps.form['period']) {
      onChange('surveyDate', null)
    }

    if (form['companyCode'] !== prevProps.form['companyCode']) {
      this.props.getAllAreasData(form['companyCode'] || '')
    }
  }

  renderSelect(label, key, placeholder, options, ...rest) {
    const { form, onChange, theme, enableField } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px',
    }
    return (
      <InputCol>
        <FieldWrapper>
          <Label
            lineheight={'14px'}
            size={'12px'}
          >
            {label}
          </Label>
          <FormSelect
            placeholder={placeholder}
            onChangeVal={(e) => onChange(key, e.target.value)}
            options={options}
            value={form[key]}
            valField={'code'}
            dispField={'name'}
            arrowSize={'3%'}
            disabled={!enableField}
            {...inputConfig}
            {...rest}
          />
        </FieldWrapper>
      </InputCol>
    )
  }

  renderDateInput(label, key, dateFormat, maxDate, minDate, disabled) {
    const { form, onChange, theme, enableField } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px',
    }

    return (
      <InputCol>
        <FieldWrapper>
          <Label
            lineheight={'14px'}
            size={'12px'}
          >
            {label}
          </Label>
          <CustomFormatDateInput
            maxDate={maxDate}
            minDate={minDate}
            val={form[key] && new Date(form[key])}
            fn={(date, field) => onChange(field, moment(date).format())}
            field={key}
            showTime
            config={inputConfig}
            dateFormat={dateFormat}
            disabled={disabled || !enableField}
          />
        </FieldWrapper>
      </InputCol>
    )
  }

  renderTimeInput(label, key, disabled, minTime, maxTime) {
    const { form, onChange, theme, enableField } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px',
    }

    return (
      <InputCol>
        <FieldWrapper>
          <Label
            lineheight={'14px'}
            size={'12px'}
          >
            {label}
          </Label>
          <TimeInputTwoVersion
            val={form[key] && new Date(form[key])}
            fn={(date, field) => onChange(field, moment(date).format())}
            field={key}
            config={inputConfig}
            disabled={disabled || !enableField}
            minTime={minTime}
            maxTime={maxTime}
          />
        </FieldWrapper>
      </InputCol>
    )
  }

  renderRomLocation() {
    const { form, onChange, areas, enableField, theme } = this.props

    const onInputChange = (e) => {
      onChange('areaCode', e)
    }

    return (
      <InputCol>
        <FieldWrapper>
          <Label
            lineheight={'14px'}
            size={'12px'}
          >
            Area
          </Label>
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                width: '100%',
                minHeight: '34px',
                maxHeight: '34px',
                borderRadius: '6px',
                borderColor: state.isFocused
                  ? theme.getRGBA(theme.mocaPurple, 0.8)
                  : theme.mocaGrey,
                boxShadow: state.isFocused
                  ? `0px 1px 1px ${theme.getRGBA(
                      theme.blackAbs,
                      0.075
                    )} inset, 0px 1px 8px ${theme.getRGBA(
                      theme.mocaPurple,
                      0.6
                    )}`
                  : 'none',
                transition: '.2s',
                '&:hover': {
                  borderColor: state.isFocused
                    ? theme.getRGBA(theme.mocaPurple, 0.8)
                    : theme.mocaGrey,
                },
              }),
              placeholder: (base) => ({
                ...base,
                fontSize: '14px',
                color: theme.black,
              }),
              valueContainer: (base) => ({
                ...base,
                paddingTop: '0px',
                paddingBottom: '0px',
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: theme.mocaPurple,
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: '32px',
              }),
              indicatorSeparator: () => ({}),
            }}
            placeholder={'Select area'}
            getOptionValue={({ code }) => code}
            getOptionLabel={({ code }) => code}
            options={areas || []}
            value={form.areaCode}
            onChange={(e) => onInputChange(e)}
            disabled={!enableField}
          />
        </FieldWrapper>
      </InputCol>
    )
  }

  render() {
    const {
      viewState: { isMobileView },
      form,
      onChange,
      onChangeForm,
      lookups,
      enableField,
    } = this.props
    const maxDatePeriode = moment().toDate()
    const minDatePeriode = moment()
      .subtract(1, 'month')
      .startOf('month')
      .toDate()
    const maxDateSurvey = moment().toDate()
    const minDateSurvey = form['period']
      ? moment(form['period']).add(1, 'day').toDate()
      : null

    return (
      <RoundedWrapper isMobile={isMobileView}>
        <MainWrapper>
          <LevelRowContainer>
            {this.renderSelect(
              'Company',
              'companyCode',
              'Select company',
              lookups.companies ? lookups.companies : []
            )}
            {this.renderRomLocation()}
          </LevelRowContainer>
          <LevelRowContainer>
            {this.renderDateInput(
              'Periode',
              'period',
              'periode_format',
              maxDatePeriode,
              minDatePeriode
            )}
            {this.renderDateInput(
              'Survey Date',
              'surveyDate',
              'DD-MMM-YYYY',
              maxDateSurvey,
              minDateSurvey,
              !form['period']
            )}
          </LevelRowContainer>
          <LevelRowContainer>
            <Attachments
              form={form}
              onChange={onChange}
              onChangeForm={onChangeForm}
              enableField={enableField}
            />
          </LevelRowContainer>
        </MainWrapper>
      </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  lookups.companies = lo.uniqBy(
    state.userLogin.userDetail.allowedCompanies.map((d) => ({
      name: d.name,
      code: d.code,
    })),
    'name'
  )

  return {
    userLogin: state.userLogin,
    viewState: state.viewState,
    lookups,
    areas: state.areaList,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleIsLoading,
      getAllAreasData,
    },
    dispatch
  )

export default withRouter(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(StockOpnameHeaderForm))
)
